<template>
  <n-space align="center" :size="[40, 0]">
    <router-link to="/">
      <h3 style="color: black">InsightPeer</h3>
    </router-link>
  </n-space>
</template>

<script>
export default {
  name: "logo"
}
</script>

<style scoped>

</style>
